import { render } from "./AttendanceList.vue?vue&type=template&id=142fbd6c&ts=true"
import script from "./AttendanceList.vue?vue&type=script&lang=ts"
export * from "./AttendanceList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__